import apiG from "./apiG";
import {apiName, paths} from "./config";

export default {
    getProducts: async (qs) => apiG.get(null, paths.products.products.all, apiName, qs),

}